import GroupButtonBody from './GroupButtonBody';

const View = (props) => <GroupButtonBody {...props} />;

export default View;
